import { render, staticRenderFns } from "./TypedList.vue?vue&type=template&id=0d283dc9&scoped=true&"
import script from "./TypedList.vue?vue&type=script&lang=ts&"
export * from "./TypedList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d283dc9",
  null
  
)

export default component.exports